var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeadericone2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5001 10.572L11.0001 18L3.50006 10.572C3.00536 10.0906 2.6157 9.51201 2.3556 8.87263C2.09551 8.23325 1.97062 7.54694 1.98879 6.85693C2.00697 6.16691 2.16782 5.48813 2.46121 4.86333C2.75461 4.23853 3.17419 3.68125 3.69354 3.22657C4.21289 2.7719 4.82076 2.42968 5.47887 2.22147C6.13697 2.01327 6.83106 1.94358 7.51743 2.0168C8.20379 2.09001 8.86756 2.30455 9.46693 2.6469C10.0663 2.98925 10.5883 3.45199 11.0001 4.00599C11.4136 3.45602 11.9362 2.99731 12.5352 2.6586C13.1341 2.31988 13.7966 2.10844 14.481 2.03751C15.1654 1.96658 15.8571 2.03769 16.5128 2.24639C17.1685 2.45508 17.7741 2.79687 18.2916 3.25036C18.8091 3.70385 19.2275 4.25928 19.5205 4.88189C19.8135 5.50449 19.9748 6.18088 19.9944 6.8687C20.0139 7.55653 19.8913 8.24099 19.6342 8.87924C19.3771 9.5175 18.991 10.0958 18.5001 10.578",
    stroke: "#4C5966",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadericone2);
export default __webpack_public_path__ + "static/media/headericone2.45874d80d02c9fa27029a8dad5e18b7f.svg";
export { ForwardRef as ReactComponent };